<template>
  <div id="notfound">
		<div class="notfound-bg">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
		<div class="notfound">
			<div class="notfound-404">
				<h1>404</h1>
			</div>
			<h2>صفحه مورد نظر یافت نشد!</h2>
			<p>احتمالا صفحه مورد نظر شما حذف یا تغییر نام داده شده است.</p>
			<router-link to="/"> بازگشت</router-link>


		</div>
	</div>
</template>

<script>
export default {

}
</script>

<style scoped>


* {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

body {
  padding: 0;
  margin: 0;
  direction: rtl;
}




</style>